document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.special-offers-button');
  const drawer = document.querySelector('.special-offers-drawer');
  const overlay = document.querySelector('.special-offers-overlay');
  const close = document.querySelector('.drawer-close');

  if (!button) return;

  const openDrawer = () => {
    drawer.classList.add('open');
    overlay.classList.add('open');
  };

  const closeDrawer = () => {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
  };

  button.addEventListener('click', openDrawer);
  close.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.querySelectorAll('.copy-coupon').forEach(btn => {
    btn.addEventListener('click', () => {
      navigator.clipboard.writeText(btn.dataset.coupon);
      btn.innerText = 'Copiado!';
      setTimeout(() => {
        btn.innerText = btn.dataset.original || 'Copiar';
      }, 2000);
    });
  });
});
